import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu,Tooltip,Badge   } from 'antd';
import { useSelector } from 'react-redux';
import {
  AppstoreOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
  UserOutlined,
  FileUnknownOutlined,
  SolutionOutlined,
  InfoCircleOutlined,
  TeamOutlined,
  ProjectOutlined,
  HomeOutlined,
  BookOutlined
} from '@ant-design/icons';

const createMenuItems = () => ({
  manufacturer: [
    {
      label: 'Inspections',
      key: 'inspections',
      icon: <FileSearchOutlined />,
      children: [
        {
          label: 'Open Inspections',
          key: 'open-inspections',
          icon: <FileSearchOutlined />,
        },
        {
          label: 'Archived Claims',
          key: 'archived-claims',
          icon: <FolderOpenOutlined />,
        },
        {
          label: 'UnAssigned Claims',
          key: 'unassigned-claims',
          icon: (
            <Badge dot>
              <FileUnknownOutlined />
            </Badge>
          ),
          requiresMohawk: true,
        },
        {
          label: 'Field Services',
          key: 'field-services',
          icon: <SolutionOutlined />,
          requiresMohawk: true,
        },
      ],
    },
    {
      label: 'Claim Analysts',
      key: 'claim-analysts',
      icon: <UserOutlined />,
    },
    {
      label: 'Distributors or Dealers',
      key: 'dealers',
      icon: <AppstoreOutlined />,
    },
    {
      label: 'Industry Standards',
      key: 'industry-standards',
      icon: <FileTextOutlined />,
    },
  ],
  'claim-analyst': [
    {
      label: 'Inspections',
      key: 'inspections',
      icon: <FileSearchOutlined />,
      children: [
        {
          label: 'All Claims',
          key: 'all-claims',
          icon: <FileSearchOutlined />,
        },
        {
          label: 'Archived Claims',
          key: 'archived-claims',
          icon: <FolderOpenOutlined />,
        },
        {
          label: 'UnAssigned Claims',
          key: 'unassigned-claims',
          icon: <UserOutlined />,
          requiresMohawk: true,
        },
        {
          label: 'Field Services',
          key: 'field-services',
          icon: <SolutionOutlined />,
          requiresMohawk: true,
        },
      ],
    },
    {
      label: 'Industry Standards',
      key: 'industry-standards',
      icon: <FileTextOutlined />,
    },
  ],
  dealer: [
    {
      label: 'Claim Requests',
      key: 'open-inspections',
      icon: <FileSearchOutlined />,
    },
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here. You can also add images from your computer or camera for editing and annotation.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresAdmin: false,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
        },
      ],
    },
  ],
  inspector: [
    {
      label: 'Inspections',
      key: 'inspections',
      icon: <FileSearchOutlined />,
      children: [
        {
          label: 'Open Inspections',
          key: 'open-inspections',
          icon: <FileSearchOutlined />,
        },
        {
          label: 'Completed Reports',
          key: 'completed-reports',
          icon: <FileDoneOutlined />,
        },
      ],
    },
    {
      label: 'All Clients',
      key: 'all-clients',
      icon: <AppstoreOutlined />,
      requiresFullAccess: true,
    },
    {
      label: 'All Invoices',
      key: 'all-invoices',
      icon: <AppstoreOutlined />,
      requiresFullAccess: true,
    },
    {
      label: 'Industry Standards',
      key: 'industry-standards',
      icon: <FileTextOutlined />,
      requiresFullAccess: true,
    },
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here. You can also add images from your computer or camera for editing and annotation.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresAdmin: false,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
        },
      ],
    },
    {
      label: 'Installation Guide',
      key: 'Installation Guide',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here. You can also add images from your computer or camera for editing and annotation.">
          <BookOutlined />
        </Tooltip>
      ),
      requiresAdmin: false,  
    },
  ],
  installer: [
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here. You can also add images from your computer or camera for editing and annotation.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresAdmin: false,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
        },
      ],
    }
  ],
    fs_manager: [
    {
      label: 'Home',
      key: 'home',
      icon: <HomeOutlined />,
    },
    {
      label: 'Projects',
      key: 'projects',
      icon: <ProjectOutlined />,
    },
    {
      label: 'Manage Inspectors',
      key: 'field-service-inspectors',
      icon: <TeamOutlined />,
    }],
    fs_inspector: [
    {
      label: 'Home',
      key: 'home',
      icon: <HomeOutlined />,
    },
    {
      label: 'Projects',
      key: 'projects',
      icon: <ProjectOutlined />,
    }],
  'trusted-dealer': [
    {
      label: 'Customer Leads',
      key: 'customer-leads',
      icon: <FileSearchOutlined />,
    },
    {
      label: 'Requested Inspections',
      key: 'requested-inspections',
      icon: <FileDoneOutlined />,
    },
    {
      label: 'Installers',
      key: 'all-installers',
      icon: <TeamOutlined />,
    },
    {
      label: 'Dashboard',
      key: 'trusted-dealer-dashboard',
      icon: <AppstoreOutlined />,
    },
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here. You can also add images from your computer or camera for editing and annotation.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresPaid: true,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
        },
      ],
    },
  ],
  'flooring-consultant': [
    {
      label: 'Consultant Profile',
      key: 'consultant-profile',
      icon: <UserOutlined />,
    },
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here for active paid consultants.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresPaid: true,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
        },
      ],
    },
  ],
  'cleaning-restoration': [
    {
      label: 'Company Profile',
      key: 'cleaning-dashboard',
      icon: <UserOutlined />,
    },
    {
      label: 'Photo Projects',
      key: 'projects',
      icon: (
        <Tooltip title="Photos from FD PhotoApp will appear here for active paid members.">
          <InfoCircleOutlined />
        </Tooltip>
      ),
      requiresPaid: true,
      children: [
        {
          label: 'All Projects',
          key: 'all-projects',
          icon: <ProjectOutlined />,
          requiresPaid: true,
        },
        {
          label: 'Photo Reports',
          key: 'photo-reports',
          icon: <FileTextOutlined />,
          requiresPaid: true,
        },
      ],
    },
  ],
});

const PATH_TO_KEY_MAP = {
  '/customer-leads': 'customer-leads',
  '/requested-inspections': 'requested-inspections',
  '/trusted-dealer-dashboard': 'trusted-dealer-dashboard',
  '/consultant-profile': 'consultant-profile',
  '/consultant-dashboard': 'consultant-profile',
  '/cleaning-dashboard': 'cleaning-dashboard',
  '/cleaning-profile': 'cleaning-dashboard',
  '/all-installers': 'all-installers',
  '/inspection-reports': 'open-inspections',
  '/inspection-completed-reports': 'completed-reports',
  '/claim-analyst-panel': 'all-claims',
  '/archived': 'archived-claims',
  '/unassigned-claims': 'unassigned-claims',
  '/field-services': 'field-services',
  '/AllClaimAnalysts': 'claim-analysts',
  '/dealers': 'dealers',
  '/industry-standards': 'industry-standards',
  '/installer-panel': 'projects',
  '/projects': 'projects',
  '/all-clients': 'all-clients',
  '/all-invoices': 'all-invoices',
  '/projects': 'all-projects',
  '/photo-reports': 'photo-reports',
  '/installation-guide':'Installation Guide',
  '/field-service-inspectors': 'field-service-inspectors',
  '/': 'home'
};

const isTrue = (val) => val === true || val === '1' || val === 1 || val === 'true';

const getMenuItems = (role, userDetails = {}, propIsPaid = false) => {
  const { is_mohawk, is_admin, limited_access, is_premium: rawPremium, is_active_paid } = userDetails || {};
  const isConsultant = role === 'um_flooring-consultant' || userDetails?.user_role === 'um_flooring-consultant';
  const isCleaning = role === 'um_cleaning-restoration' || userDetails?.user_role === 'um_cleaning-restoration';
  const isPaidFlag = propIsPaid || isTrue(rawPremium) || isTrue(is_active_paid);
  const hasConsultantPaid = isConsultant && (isPaidFlag || ['27', '28'].includes(String(userDetails?.membership_id || userDetails?.membersdhip_level)));
  const hasCleaningPaid = isCleaning && (isPaidFlag || ['29'].includes(String(userDetails?.membership_id || userDetails?.membersdhip_level)));
  const is_premium = isPaidFlag || role === 'um_trusted-dealer' || userDetails?.user_role === 'um_trusted-dealer' || hasConsultantPaid || hasCleaningPaid;
  const roleKey = role?.replace('um_', '') || '';
  const menuItems = createMenuItems();

  const filterMenuItems = (items) => {
    return items.map(item => {
      const isDisabled = (
        (item.requiresFullAccess && limited_access) ||
        (item.requiresAdmin && !is_admin) ||
        (item.requiresPaid && !is_premium)
      );

      return {
        ...item,
        disabled: isDisabled,
        children: item.children?.map(child => ({
          ...child,
          disabled: isDisabled || (child.requiresPaid && !is_premium),
        })).filter(child =>
          !child.requiresMohawk || (child.requiresMohawk && is_mohawk)
        ),
      };
    }).filter(item => 
      (!item.requiresAdmin || (item.requiresAdmin && is_admin))
    );
  };

  return filterMenuItems(menuItems[roleKey] || []);
};

const ButtonNavigation = ({ isPaid: propIsPaid = false }) => {
  const [current, setCurrent] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useSelector((state) => state.User.userDetails);

  useEffect(() => {
    const currentPath = location.pathname;
    setCurrent(PATH_TO_KEY_MAP[currentPath] || '');
  }, [location.pathname]);

  const onClick = (e) => {
    const path = Object.entries(PATH_TO_KEY_MAP).find(([_, value]) => value === e.key)?.[0];
    if (path) {
      setCurrent(e.key);
      navigate(path);
    }
  };

  const items = getMenuItems(userDetails?.user_role, userDetails, propIsPaid);

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
      style={{ fontSize: '1rem' }}
    />
  );
};

export default ButtonNavigation;